import { Typography } from "@mui/material";
import { motion } from "framer-motion";

const defaultWords = [
  { text: "Breaking", top: "8%", left: "6%", rotate: -18, size: "5.5rem" },
  { text: "Updates", top: "18%", right: "5%", rotate: 18, size: "5rem" },

  { text: "Gaming", top: "34%", left: "3%", rotate: -8, size: "6rem" },
  { text: "Esports", top: "42%", right: "4%", rotate: 15, size: "5rem" },

  { text: "Community", top: "60%", left: "8%", rotate: -20, size: "5.5rem" },
  { text: "Exclusive", top: "72%", right: "6%", rotate: 22, size: "5rem" },

  { text: "Fox", top: "88%", left: "18%", rotate: -15, size: "7rem" },
  { text: "Live", top: "92%", right: "18%", rotate: 12, size: "4.5rem" },
];

const BackgroundWords = ({
  words = defaultWords,
  color = "#ff6f00",
}) => {
  return (
    <>
      {words.map((word, index) => (
        <motion.div
          key={index}
          initial={{
            opacity: 0,
            scale: 0.9,
          }}
          animate={{
            opacity: 1,
            y: [0, -10, 0],
            rotate: [
              word.rotate,
              word.rotate + 2,
              word.rotate,
            ],
          }}
          transition={{
            opacity: {
              duration: 1,
              delay: index * 0.12,
            },
            y: {
              duration: 12 + index,
              repeat: Infinity,
              ease: "easeInOut",
            },
            rotate: {
              duration: 14 + index,
              repeat: Infinity,
              ease: "easeInOut",
            },
          }}
          style={{
            position: "absolute",
            zIndex: 1,
            pointerEvents: "none",
            userSelect: "none",
            ...word,
          }}
        >
          <Typography
            sx={{
              fontFamily: "Impact, sans-serif",

              fontSize: {
                xs: "2rem",
                md: word.size,
              },

              color,

              opacity: 0.055,

              letterSpacing: "3px",

              whiteSpace: "nowrap",

              textTransform: "uppercase",

              textShadow: "2px 2px 6px rgba(0,0,0,.35)",
            }}
          >
            {word.text}
          </Typography>
        </motion.div>
      ))}
    </>
  );
};

export default BackgroundWords;